import { Align, BarElement, CategoryScale, Chart, Legend, LinearScale, Title } from 'chart.js';
import { t } from 'i18next';
import { Bar } from 'react-chartjs-2';

import { useScenarioContext } from 'providers';

Chart.register(BarElement, CategoryScale, LinearScale, Title, Legend);

function getChartColorFromCSS(color: string) {
    const style = getComputedStyle(document.body);
    return style.getPropertyValue(`--color-${color}`);
};

function getChartColor(highlighted?: boolean) {
    return highlighted ?
        getChartColorFromCSS('chart-category6') :
        getChartColorFromCSS('chart-category7');;
}

type ScenarioChartProps = {
    type: 'footprint' | 'costs'
}

export const ScenarioChart = ({ type }: ScenarioChartProps) => {
    const scenarios = useScenarioContext();

    const recommendedColor = getChartColor(true);
    const defaultColor = getChartColor(false);

    const data = {
        labels: scenarios.map((_, index) => `${t('scenario')} ${index + 1}`),
        datasets: (type === 'footprint') ?
            [{
                id: 1,
                label: 'kg CO₂',
                data: scenarios.map(scenario => scenario.summary?.co2Total),
                backgroundColor: scenarios.map(scenario => scenario.summary?.co2Recommended ?
                    recommendedColor :
                    defaultColor)
            }] :
            [{
                id: 2,
                label: '€',
                data: scenarios.map(scenario => scenario.summary?.costsTotal),
                backgroundColor: scenarios.map(scenario => scenario.summary?.costsRecommended ?
                    recommendedColor :
                    defaultColor)
            }]
    };

    const options = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                align: 'start' as Align,
                labels: {
                    boxHeight: 32,
                    boxWidth: 0,
                    padding: 0
                }
            },
            tooltip: {
                enabled: false
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                title: {
                    display: false,
                    // text: type === 'footprint' ? 'kg CO₂' : '€',
                    // align: 'end' as Align
                },
            },
        },
    };

    return (
        <div className="w-full">
            <Bar data={data} options={options} />
        </div>);
};

